import { cn } from "@/common/helpers/utils";
import { EmptyValue } from "@/components/ui/empty-value";
import type { ReactNode } from "react";

export function DetailTabRow({ label, value, mono = false }: { label: string; value?: ReactNode; mono?: boolean }) {
  const isEmpty = value === null || value === undefined || value === "";

  return (
    <div className="grid grid-cols-[7.5rem_minmax(0,1fr)] items-baseline gap-x-4 py-1.5">
      <span className="text-muted-foreground truncate text-sm">{label}</span>
      <span className={cn("text-sm wrap-anywhere", mono && "font-mono")}>{isEmpty ? <EmptyValue /> : value}</span>
    </div>
  );
}
